"use client"

import { useState, useEffect } from "react"
import "./Notification.css"

const Notification = ({ message, type = "success", duration = 3000, onClose }) => {
  const [visible, setVisible] = useState(true)

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false)
      if (onClose) setTimeout(onClose, 300) // Allow time for fade-out animation
    }, duration)

    return () => clearTimeout(timer)
  }, [duration, onClose])

  const getIcon = () => {
    switch (type) {
      case "success":
        return "fa-check-circle"
      case "error":
        return "fa-exclamation-circle"
      case "warning":
        return "fa-exclamation-triangle"
      case "info":
        return "fa-info-circle"
      default:
        return "fa-bell"
    }
  }

  const handleClose = () => {
    setVisible(false)
    if (onClose) setTimeout(onClose, 300)
  }

  return (
    <div className={`notification ${type} ${visible ? "visible" : "hidden"}`}>
      <div className="notification-icon">
        <i className={`fas ${getIcon()}`}></i>
      </div>
      <div className="notification-content">{message}</div>
      <button className="notification-close" onClick={handleClose}>
        <i className="fas fa-times"></i>
      </button>
    </div>
  )
}

export default Notification
